import type { Coverage } from 'fhir/r4';
import { CoverageClassCode } from '../coding';
import { getReferenceType } from '.';
import { isCodingInList } from './coding';

/**
 * Check if the reference to a `beneficiary` and `subscriber` are the same.
 * @returns `true` if the references are defined and equal, otherwise false
 */
export const isPatientMainMember = ({
  beneficiary,
  subscriber,
}: Coverage): boolean =>
  !!beneficiary.reference && beneficiary.reference === subscriber?.reference;

export const getPlan = (coverage: Coverage) =>
  coverage.class?.find((coverageClass) =>
    isCodingInList(CoverageClassCode.Plan, coverageClass?.type?.coding),
  );

export const getSubPlan = (coverage: Coverage) =>
  coverage.class?.find((coverageClass) =>
    isCodingInList(CoverageClassCode.SubPlan, coverageClass?.type?.coding),
  );

type AllowedSubscriber = 'Patient' | 'RelatedPerson';

const allowedSubscriberTypes: AllowedSubscriber[] = [
  'Patient',
  'RelatedPerson',
];

/**
 * Get the type of the resource to be used for fetching the subscriber
 * @param coverage
 * @returns the type of the subscriber
 */
export const getSubscriberType = (
  coverage?: Coverage,
): AllowedSubscriber | undefined => {
  if (!coverage) {
    return undefined;
  }

  const subscriberType = getReferenceType(coverage.subscriber);

  const resolvedType = allowedSubscriberTypes.find(
    (resourceType) => resourceType === subscriberType,
  );

  return resolvedType;
};

export interface CoverageIdentifiers {
  schemeCode: string;
  dependantCode: string;
  subscriberId: string;
}
